import React from 'react';
import { Layout } from 'tea-component';
import CardCommon from '@op/components/CardCommon';
import './index.scss';
import useIntls from '@opm/hooks/useIntls';

const { Content } = Layout;

const NotFound: React.FC = () => {
  const { intl } = useIntls();

  return (
    <Content className="dbo-page not-found-wrapper">
      <Content.Body>
        <CardCommon
          emptyHeight={760}
          empty
          hasEmptyTitle={true}
          emptyTitleText={intl('Unrecognized Link')}
          emptyDescText={intl("The system doesn't recognize the format of the link you entered. Please verify the link and try again.")}
        />
      </Content.Body>
    </Content>
  );
};

export default NotFound;
